














import { Component, Prop, Vue } from "vue-property-decorator";
import { ProgramPackTexts } from "../../bookings/programPackTexts";
import CzCard from "../cz/CzCard.vue";
import CzChip from "../cz/CzChip.vue";
import CzTitle from "../cz/CzTitle.vue";
import CzRing from "../cz/CzRing.vue";
import CzSegments from "../cz/CzSegments.vue";

// The header of a patient's program: status, name and how far it has gone. In My plan it is also the card to pick it.
@Component({ components: { CzCard, CzChip, CzTitle, CzRing, CzSegments } })
export default class ProgramPackHead extends Vue {
  @Prop({ type: Object, required: true }) enrollment!: any;
  @Prop({ type: Object, default: () => ({}) }) guidelines!: { [id: number]: any };
  @Prop({ type: [String, Object], default: "" }) to!: string | object;
  @Prop({ type: Boolean, default: false }) selected!: boolean;

  texts = ProgramPackTexts;

  get progress(): { value: number; max: number; label: string } {
    return ProgramPackTexts.progress(this.t, this.enrollment, this.guidelines);
  }

  t(key: string): string {
    return this.$t(key).toString();
  }
}
